import { RequestInstance } from "@/utils/request";

export const expressionCalculate = new RequestInstance({
  method: "post",
  url: "/v2/expression/calculate",
});

export const ruleEngineInfo = new RequestInstance({
  method: "get",
  url: "/v2/rule/engine/info",
});

export const ruleEngineUpdate = new RequestInstance({
  method: "post",
  url: "/v2/rule/engine/update",
});

export const thingsModelPage = new RequestInstance({
  method: "get",
  url: "/v2/things/model/page",
});

export const modelPropertyPage = new RequestInstance({
  method: "get",
  url: "/v2/model/property/page",
});

export const modelPropertyDevicePage = new RequestInstance({
  method: "get",
  url: "/v2/model/property/device/page",
});

export const enumerationList = new RequestInstance({
  method: "get",
  url: "/v2/rule/tag/page",
});
